import React, { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react';
import { Popup, Button, PickerView } from 'antd-mobile';
import { useMount, useSetState } from 'ahooks';
import lookie from 'lookie';
import dayjs, { Dayjs } from 'dayjs';
import service from '@/service';
import { SELECTED_CUSTOMER_ID } from '@/constant';
import { setFormValue, useAIDiagnoseStore } from '../../store/useAIDiagnoseStore';

import cx from './index.module.scss';

interface Props {
  isShow: boolean;
  setIsShow: Dispatch<SetStateAction<boolean>>;
  value: Dayjs;
  onChange: (date: Dayjs) => void;
}

// 获取某年某月有多少天
const getDaysInMonth = (year: number, month: number) => {
  return dayjs(`${year}-${month}-01`).daysInMonth();
};

export const BirthdaySelector: React.FC<Props> = ({ isShow, setIsShow, value, onChange }) => {
  const { userInfo } = useAIDiagnoseStore.use.formValue();

  const [date, setDate] = useSetState({
    year: 0,
    month: 0,
    day: 0,
  });

  const yearColumn = useMemo(
    () => [
      [...Array(101)].map((_, index) => {
        const currentYear = dayjs().year() - 100 + index;
        return {
          value: currentYear,
          label: `${currentYear} 年`,
        };
      }),
    ],
    []
  );
  const monthColumn = useMemo(
    () => [
      [...Array(12)].map((_, index) => ({
        value: index + 1,
        label: `${index + 1} 月`,
      })),
    ],
    []
  );

  const dayColumn = useMemo(
    () =>
      date?.year
        ? [
            [...Array(getDaysInMonth(date?.year, date?.month))].map((_, index) => ({
              value: index + 1,
              label: `${index + 1} 日`,
            })),
          ]
        : [],
    [date]
  );

  // 根据选择的顾客设置默认值
  const getCustomerInfo = useCallback(async () => {
    const { data } = await service.customer.getCustomerProfile(lookie.get(SELECTED_CUSTOMER_ID));

    // 在用户未选性别的情况下设置默认用户性别
    if (!userInfo?.gender && data?.gender) {
      setFormValue({ userInfo: { gender: data?.gender } }, { isMerge: true });
    }

    if (!userInfo?.birthday && data?.birthday) {
      setDate({
        year: dayjs(data?.birthday).year(),
        month: dayjs(data?.birthday)?.month() + 1,
        day: dayjs(data?.birthday)?.date(),
      });
      setFormValue({ userInfo: { birthday: dayjs(data?.birthday) } }, { isMerge: true });
    }
  }, [setDate, userInfo]);

  useMount(getCustomerInfo);

  useEffect(() => {
    if (isShow && value) {
      setDate({
        year: +dayjs(value)?.year(),
        month: +dayjs(value)?.month() + 1,
        day: +dayjs(value)?.date(),
      });
    } else {
      // TODO 取默认值
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow, value]);

  return (
    <Popup
      bodyClassName={cx('BirthdaySelector')}
      visible={isShow}
      destroyOnClose={true}
      onMaskClick={() => {
        setIsShow(false);
      }}
      onClose={() => {
        setIsShow(false);
      }}
    >
      <div className={cx('title')}>选择生日</div>
      <div className={cx('content')}>
        <div className={cx('picker-view-item')}>
          <PickerView
            className={cx('picker-view')}
            columns={yearColumn}
            value={[date?.year]}
            onChange={v => setDate({ year: v[0] as number })}
          />
        </div>
        <div className={cx('picker-view-item')}>
          <PickerView
            className={cx('picker-view')}
            columns={monthColumn}
            value={[date?.month]}
            onChange={v => setDate({ month: v[0] as number })}
          />
        </div>
        <div className={cx('picker-view-item')}>
          <PickerView
            className={cx('picker-view')}
            columns={dayColumn}
            value={[date?.day]}
            onChange={v => setDate({ day: v[0] as number })}
          />
        </div>
      </div>
      <div className={cx('footer')}>
        <Button
          className={cx('btn')}
          color="primary"
          onClick={() => {
            setIsShow(false);
            onChange?.(dayjs(`${date?.year}-${date?.month}-${date?.day}`));
          }}
        >
          确定
        </Button>
      </div>
    </Popup>
  );
};
